import Alpine from 'alpinejs';

Alpine.data('offcanvas', () => ({

    is_open: false,
    
    init() {
        var self = this;
        window.addEventListener('offcanvas:toggle', () => self.toggle());
        window.addEventListener('offcanvas:open', () => self.open());
    },

    toggle() {
        this.is_open ? this.close() : this.open();
    },

    open() {
        this.is_open = true;
        document.body.classList.add('overflow-hidden');
        window.Fancybox?.close();
    },

    close() {
        this.is_open = false;
        document.body.classList.remove('overflow-hidden');
        window.Fancybox?.close();
    }
}));